import { render } from "./PaymentAbleMenu.vue?vue&type=template&id=3797227b"
import script from "./PaymentAbleMenu.vue?vue&type=script&lang=js"
export * from "./PaymentAbleMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__